module.exports = __webpack_public_path__ + "images/editFooterVector.928aa5c6.svg";